import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { COLORS } from '~/src/styles/tokens/colors';

export const animationSpeed = 2;
export const textBlockBorderRadius = BORDER_RADIUS.medium6;
export const skeletonBackgroundColor = COLORS.backgroundSkeleton;
export const skeletonForegroundColor = COLORS.foregroundSkeleton;
